import memoizeOne, { type MemoizedFn } from 'memoize-one';

export const eventMemoryPlugin: MemoizedFn<
	() => {
		// @ts-ignore
		'event:memory': any;
	} | null
> = memoizeOne(
	(): {
		// @ts-ignore
		'event:memory': any;
	} | null => {
		// @ts-ignore: deviceMemory is exposed in some browsers
		if (!navigator.deviceMemory) {
			return null;
		}
		return {
			// @ts-ignore
			'event:memory': navigator.deviceMemory,
		};
	},
);
